import Organisation from '../Models/Organisation';
import DataGridRequest from './DataGridRequest';
export class OrganisationsRequest extends DataGridRequest<Organisation> {
    Url = '/subscribers/organisations/api';
}
